import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=3e730a4a&scoped=true&"
import script from "./orderList.js?vue&type=script&lang=js&"
export * from "./orderList.js?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=3e730a4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e730a4a",
  null
  
)

export default component.exports